import { storage } from '@/components/Storage';
import { user } from '@/components/User.js';
import m from 'mithril';
import { modalContainerWarningAudioRecord } from './Modal/ModalContainerWarningAudioRecord';


export let currentDateTime = null;
export function setCurrentDateTime(dt) {
    currentDateTime = dt;
}

export const TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export function isUnreadMsg() {
    const msg = localStorage.getItem("messages");
    if(msg) {
        var msg_arr = JSON.parse(msg);
        if(msg_arr.length == 1) {
            if(msg_arr[0]["code"] != "undefined") {
                if(msg_arr[0]["code"] == "1")
                    return false;
            }
        }
        for(let i=0; i < msg_arr.length; i++) {
            if(msg_arr[i].readed == null) {
                return true;
            }
        }
        return false;
    } else {
        return false;
    }
};

export function isEnabledMsg() {    
    return storage.config?.message_turn ?? false;
}

export function checkMessage(service_addr) {
    let user = JSON.parse(localStorage.getItem('user'));
    if(user && service_addr != "") {
        m.request({
            method: 'POST',
            url: "/api/getMessage",
            data: {'receiver': user.id, 'service_addr': service_addr }
        }).then(function (response) {
            if (response.length !== 0) {
                let msg = localStorage.getItem("messages");
                if (msg == null) {
                    let msg_json = JSON.stringify(response);
                    localStorage.setItem("messages", msg_json);
                    for(let i = 0; i < response.length; i++) {
                        if(i == 0) {
                            if(response[i].code !== undefined)
                                break;
                        }
                        if(response[i].readed == null) {
                            if (document.getElementById("modalMessage") == null)
                                ModalContainerMessage.init("modalMessage");
                            ModalContainerMessage.insertMessage("Вам пришло сообщение!", "contentText");
                            ModalContainerMessage.open();
                            break;
                        }
                    }
                } else {
                    var msg_arr = JSON.parse(msg);
                    var inxs = [];

                    for (let i = 0; i < msg_arr.length; i++) {
                        inxs.push(msg_arr[i].id);
                    }
                    for (let i = 0; i < response.length; i++) {
                        if (inxs.includes(response[i].id) === false) {
                            let msg_json = JSON.stringify(response);
                            localStorage.setItem("messages", msg_json);

                            if (document.getElementById("modalMessage") == null)
                                ModalContainerMessage.init("modalMessage");
                            ModalContainerMessage.insertMessage("Вам пришло сообщение!", "contentText");
                            ModalContainerMessage.open();
                        }
                    }
                }
            }
        }, function (response) {
        });
    }
}

export function transformDate(datetime, part, locale='ru', options={}) {
    if (!datetime)    
        return '';

    let d = new Date(datetime);
    if(part === 'date') {
        const opt = 
        {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            ...options
        };
        return d.toLocaleString(locale, opt);
    }
    else if(part === 'time') {
        const opt = {
            hour: 'numeric',
            minute: 'numeric',
            ...options
        };
        return d.toLocaleString(locale, opt);
    }
}

export function geolocation() {
    // ГеоЛокация
    if ("geolocation" in navigator) {
        var geo_options = {
            // enableHighAccuracy: true,
            maximumAge: 30000
            // timeout           : 27000
        };

        function geo_error() {
            console.log("Sorry, no position available.");
        }

        function geo_success(position) {
            /*
            coords.latitude	The latitude as a decimal number (always returned)
            coords.longitude	The longitude as a decimal number (always returned)
            coords.accuracy	The accuracy of position (always returned)
            coords.altitude	The altitude in meters above the mean sea level (returned if available)
            coords.altitudeAccuracy	The altitude accuracy of position (returned if available)
            coords.heading	The heading as degrees clockwise from North (returned if available)
            coords.speed	The speed in meters per second (returned if available)
            timestamp	The date/time of the response (returned if available)
             */
            //m.redraw.strategy("none");
            m.request({
                method: 'POST',
                url: '/api/geoposition',
                background: true,
                data: {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    heading: position.coords.heading,
                    speed: position.coords.speed,
                    timestamp: position.timestamp
                },
                extract(xhr) {
                    const statusErr = [401, 403];
                    const obj = xhr.response;
                    return statusErr.includes(xhr.status) ? xhr.status : xhr.response;
                }
            }).then(function () {
                //console.log("response");
                //m.redraw.strategy("none");
            }, function (err) {
                if ([401, 403].includes(err)) {
                    user.destroy();
                    if (m.route() !== '/login') {
                        window.location.replace('/login');
                    }
                }
            });
            //console.log("response");
        }

        // var watchID =
        navigator.geolocation.getCurrentPosition(geo_success, geo_error, geo_options);
    }
}

export function record_audio() {
    navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
            const options = {
                mimeType: 'audio/mp3',
                numberOfAudioChannels: 1,
                sampleRate: 16000,
            };
            const mediaRecorder = new MediaRecorder(stream);
            let voice = [];
            let save = false;

            document.addEventListener("startAudioRecord", function () {
                mediaRecorder.start();
            });
            /*document.querySelector('#startAudioRecord').addEventListener('click', function(){
                mediaRecorder.start();
            });*/
            mediaRecorder.addEventListener("dataavailable", function (event) {
                voice.push(event.data);
            });

            document.addEventListener("stopAudioRecord", function () {
                save = true;
                mediaRecorder.stop();
            });

            document.addEventListener("breakAudioRecord", function () {
                save = false;
                mediaRecorder.stop();
            });
            /*document.querySelector('#stopAudioRecord').addEventListener('click', function(){
                mediaRecorder.stop();
            });*/
            //localStorage.setItem("AudioRecordsName", []);
            mediaRecorder.addEventListener("stop", function () {

                if (save) {
                    const voiceBlob = new Blob(voice, {
                        type: 'audio/mp3'
                    });
                    let lengthAudio = localStorage.getItem("lengthAudio");
                    // текущая дата
                    var date = new Date();

                    // час в текущей временной зоне
                    var fileName = date.getDate().toString().padStart(2, '0') + "."
                        + (date.getMonth() + 1).toString().padStart(2, '0') + "."
                        + date.getFullYear() + " "
                        + date.getHours().toString().padStart(2, '0') + ":"
                        + date.getMinutes().toString().padStart(2, '0') + "  "
                        + "(" + lengthAudio + ")";

                    var audioData = { "fileName": fileName, "dk": date };

                    var reader = new FileReader();
                    reader.readAsDataURL(voiceBlob);
                    reader.onloadend = function () {
                        var base64data = reader.result;
                        //console.log(base64data);
                        audioData.base64Audio = base64data;
                        audioData.length = lengthAudio;
                        loader.show();
                        m.request({
                            method: 'PUT',
                            url: '/api/task/' + m.route.param('taskId') + '/saveAudioComment',
                            data: audioData
                        }).then(function (response) {
                            loader.hide();

                            var loc_audio = localStorage.getItem("AudioRecords");
                            loc_audio = JSON.parse(loc_audio);

                            const file_loc = {
                                "fileName": fileName,
                                "fileID": response.id,
                                "base64": URL.createObjectURL(voiceBlob)
                            };
                            loc_audio.unshift(file_loc);
                            localStorage.setItem("AudioRecords", JSON.stringify(loc_audio));


                            ////////////////////////////////////////////////////////////////////
                            let audioRecords = document.getElementById("audioRecords");
                            let record = document.createElement("div");
                            record.setAttribute("name", response.id);
                            record.style = 'margin-top:4px';
                            let audio = document.createElement("audio");
                            audio.src = URL.createObjectURL(voiceBlob);
                            audio.onended = function () {
                                let i = button_play.getElementsByTagName("icon")[0];
                                if (i.classList.contains("fa-pause")) {
                                    audio.pause();
                                    i.classList.remove("fa-pause");
                                    i.classList.add("fa-play");
                                }
                            };
                            record.append(audio);

                            let audio_new = document.createElement("div");
                            let name = document.createElement("div");
                            name.style = "display: flex; align-items: center;";
                            name.innerText = fileName;
                            let button_play = document.createElement("button");
                            let icon = document.createElement("icon");
                            icon.classList.add("fa");
                            icon.classList.add("fa-play");
                            button_play.append(icon);
                            button_play.onclick = function () {
                                let i = button_play.getElementsByTagName("icon")[0];
                                if (i.classList.contains("fa-play")) {
                                    audio.play();
                                    i.classList.remove("fa-play");
                                    i.classList.add("fa-pause");
                                }
                                else if (i.classList.contains("fa-pause")) {
                                    audio.pause();
                                    i.classList.remove("fa-pause");
                                    i.classList.add("fa-play");
                                }
                            };

                            let button_delete = document.createElement("button");
                            button_delete.id = response.id;
                            icon = document.createElement("icon");
                            icon.classList.add("fa");
                            icon.classList.add("fa-trash");
                            button_delete.append(icon);
                            button_delete.onclick = function (el) {
                                localStorage.setItem("selectID", el.currentTarget.id);
                                let buttons = document.createElement("div");

                                let btn_yes = document.createElement("button");
                                btn_yes.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                btn_yes.innerText = "Да";
                                btn_yes.onclick = function () {
                                    loader.show();
                                    modalContainerWarningAudioRecord.close();
                                    let id = localStorage.getItem("selectID");
                                    m.request({
                                        method: 'DELETE',
                                        url: '/api/task/' + m.route.param('taskId') + '/removeAudioComment',
                                        data: id
                                    }).then(function (response) {


                                        var loc_audio = localStorage.getItem("AudioRecords");
                                        loc_audio = JSON.parse(loc_audio);
                                        let id = localStorage.getItem("selectID");
                                        for (let i = 0; i < loc_audio.length; i++) {
                                            if (loc_audio[i].fileID == id)
                                                loc_audio.splice(i, 1);
                                        }
                                        localStorage.setItem("AudioRecords", JSON.stringify(loc_audio));

                                        let elem = document.getElementsByName(id);
                                        if (elem)
                                            document.getElementsByName(id)[0].remove();

                                        loader.hide();

                                    }, function () {
                                        loader.hide();
                                    });
                                };

                                let btn_no = document.createElement("button");
                                btn_no.classList.add('col-6', 'btn', 'btn-warning', 'btn-md');
                                btn_no.style = "margin-left: 10px;";
                                btn_no.innerText = "Нет";
                                btn_no.onclick = modalContainerWarningAudioRecord.close;
                                buttons.append(btn_yes);
                                buttons.append(btn_no);

                                modalContainerWarningAudioRecord
                                    .open("Предупреждение",
                                        "Вы действительно хотите удалить аудиосообщение?",
                                        buttons);
                            };
                            button_delete.style = "margin-left: 5px";
                            let buttons = document.createElement("div");

                            buttons.append(button_play);
                            buttons.append(button_delete);

                            audio_new.append(name);
                            audio_new.append(buttons);
                            audio_new.className = 'container';
                            audio_new.style = 'display: flex; justify-content: space-between;';

                            record.append(audio_new);
                            audioRecords.insertBefore(record, audioRecords.firstChild);
                            ///////////////////////////////////////////////////////////////////
                        }, function () {
                            loader.hide();
                        });
                    };

                }
                voice = [];
            });

            localStorage.setItem("mediaRecorder", mediaRecorder);
        });
}

